import axios from "axios";
const token = localStorage.getItem("token");

axios.defaults.headers.common["Accept"] = "application/json";

axios.defaults.baseURL = "https://smartbee.info/api";
axios.defaults.headers.common["Authorization"] = "Bearer " + `${token}`;



const instance = axios.create({
  baseURL: "https://smartbee.info/api",
});


instance.defaults.headers.common["Accept"] = "application/json";
export default instance
;


